import { Row, Col } from 'react-bootstrap';
import { CurrencyFormat } from 'components/Helpers';
import './styles.scss';

export default function PurchaseSummary({
  title = 'Resumen de compra',
  articles = [],
  className = '',
  children,
}) {
  return (
    <div className={`PurchaseSummary ${className}`}>
      <div className="PurchaseSummary__Header">
        <h6 className="PurchaseSummary__Header__Title text-uppercase text-center m-0">
          {title}
        </h6>
      </div>

      <div className="PurchaseSummary__ArticlesList">
        {articles.map(({ amount = 0, productName = '', price = 0 }) => (
          <Row className="PurchaseSummary__ArticlesList__Article">
            <Col xs={3} className="Amount">
              <p className="m-0">({amount})</p>
            </Col>
            <Col xs={6} className="Name">
              <p className="m-0">{productName}</p>
            </Col>
            <Col xs={3} className="Price">
              <CurrencyFormat price={price} className="m-0" />
            </Col>
          </Row>
        ))}
      </div>

      <div className="PurchaseSummary__Subtotal">
        <h6 className="m-0">Subtotal: </h6>
        <h6 className="m-0">
          <CurrencyFormat price={11600} className="m-0" />
        </h6>
      </div>

      <div className="PurchaseSummary__Children">{children}</div>
    </div>
  );
}
